import React, { useState } from "react";
import BaseModal from "../../../components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";


export default function CommissionTypeFormModal({ show, onClose, mode, userData, onSuccess }) {
  const [errors, setErrors] = useState({});
  const {userid} = useSession();

  const validateForm = () => {
    const name = document.getElementById("name").value.trim();
    const type = document.querySelector('select[name="type"]').value;
    const status = document.querySelector('select[name="status"]').value;

    let newErrors = {};

    if (!name) {
      newErrors.name = "Name is required.";
    } else if (name.length < 3) {
      newErrors.name = "Name must be at least 3 characters.";
    }

    if (!type) {
      newErrors.type = "Please select scheme type.";
    }

    if (!status) {
      newErrors.status = "Please select status.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      showMainToast("Please correct the errors before saving.", "danger");
      return;
    }

    const name = document.getElementById("name").value.trim();
    const type = document.querySelector('select[name="type"]').value;
    const status = document.querySelector('select[name="status"]').value;

    const formData = new FormData();
    formData.append("name", name);
    formData.append("type", type);
    formData.append("status", status);
    formData.append("action", "ADDUpdate");
    formData.append("userid", userid);
    formData.append("id", userData?.id || "");

    try {
      const response = await fetch("https://pro.mokshiq.in/commission_type_manager_action", {
        method: "POST",
         headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: formData,
      });

      if (!response.ok) {
        showMainToast("Something went wrong!", "danger");
      }

      const result = await response.json();
      if (result.status) {
        showMainToast(result.data || "Success!", "success");
        onClose();
         if (onSuccess) onSuccess();
      } else {
        showMainToast(result.data || "Something went wrong!", "danger");
      }
    } catch (error) {
      showMainToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={mode === "edit" ? "Edit Commission Type" : "Add Commission Type"}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: mode === "edit" ? "Update" : "Save", className: "btn-primary", onClick: handleSave },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="form-validation">
          {/* Name */}
          <div className="col-md-6">
            <label className="form-label" htmlFor="name">Name</label>
            <input
              className={`form-control ${errors.name ? "is-invalid" : ""}`}
              id="name"
              name="name"
              type="text"
              defaultValue={userData?.Name || ""}
            />
            {errors.name && <div className="text-danger mt-1">{errors.name}</div>}
          </div>

          {/* Type */}
          <div className="col-md-6">
            <label className="form-label">Scheme Type</label>
            <select
              className={`form-select w-100 ${errors.type ? "is-invalid" : ""}`}
              name="type"
              defaultValue={userData?.Type || ""}
            >
              <option value="">-- Select --</option>
            
              <option value="commission">Commission</option>
              <option value="charge">Charge</option>
            </select>
            {errors.type && <div className="text-danger mt-1">{errors.type}</div>}
          </div>

          {/* Status */}
          <div className="col-md-6">
            <label className="form-label">Status</label>
            <select
              className={`form-select w-100 ${errors.status ? "is-invalid" : ""}`}
              name="status"
              defaultValue={userData?.Status || ""}
            >
              <option value="">-- Select --</option>
              <option value="True">Active</option>
              <option value="False">Inactive</option>
            </select>
            {errors.status && <div className="text-danger mt-1">{errors.status}</div>}
          </div>
        </form>
      </div>
    </BaseModal>
  );
}
